(function() {

  'use strict';

  angular
    .module('mgpCorregedoriaApp.validacao')
    .controller('DashboardController', DashboardController);

  function DashboardController(DataService, DashboardService) {

    var vm = this;

    vm.init = init;
    vm.convertDate = convertDate;

    vm.init();

    function init() {
      DashboardService.loadEstatisticaRelatoriosEnviados().then( (data) => {
        vm.statusEnvioList = data;
      });
    }

    function convertDate(date) {
      return DataService.convertDate(date);
    }
  }

})();
